var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1995_139295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23808 0.00195312H24.7619C28.7619 0.00195312 32 3.24005 32 7.24003V24.7639C32 28.7639 28.7619 32.002 24.7619 32.002H7.23808C3.2381 32.002 0 28.7639 0 24.7639V7.24003C0 3.24005 3.2381 0.00195312 7.23808 0.00195312Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3671 4.44264C17.5762 4.19316 16.7288 4.05664 15.8532 4.05664C13.2969 4.05664 11.009 5.21 9.479 7.02716L13.4099 10.332L18.3671 4.44264Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47879 7.02734C8.21851 8.52422 7.52815 10.4185 7.52979 12.3753C7.52979 13.9382 7.84051 15.2093 8.35363 16.3439L13.4097 10.3321L9.47879 7.02734Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 9.19828C16.4595 9.19884 17.0535 9.3728 17.5648 9.69968C18.0761 10.0265 18.4834 10.4927 18.7386 11.0432C18.9939 11.5938 19.0865 12.2058 19.0055 12.8072C18.9246 13.4087 18.6735 13.9744 18.2818 14.438L23.2343 8.54864C22.2177 6.59012 20.4652 5.11528 18.3618 4.44824L13.4141 10.3376C13.7122 9.98052 14.0851 9.6934 14.5065 9.49652C14.9279 9.29968 15.3875 9.19784 15.8526 9.19828Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8524 15.5624C14.0964 15.5624 12.67 14.136 12.67 12.38C12.6679 11.6324 12.9315 10.9083 13.4138 10.3369L8.35303 16.3486C9.21923 18.2646 10.6551 19.8041 12.1333 21.7436L18.2815 14.4373C17.9828 14.7902 17.6107 15.0738 17.1912 15.2681C16.7716 15.4624 16.3147 15.5629 15.8524 15.5624Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1593 23.7355C20.9369 19.395 24.171 17.4225 24.171 12.3758C24.171 10.9918 23.8321 9.68774 23.2342 8.53906L12.1382 21.7441C12.6089 22.3608 13.0844 23.0152 13.5458 23.7402C15.2311 26.3482 14.7651 27.9112 15.8525 27.9112C16.94 27.9112 16.474 26.3435 18.1593 23.7355Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1995_139295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmapIcon);
export default __webpack_public_path__ + "static/media/gmap-icon.5e64b84fb074eb09f9bf81312a4e3969.svg";
export { ForwardRef as ReactComponent };